import React from "react";
import { PlusCircle, CreditCard, LifeBuoy } from "lucide-react";

const CreditsCard = () => {
  return (
    <div
      className="
        relative rounded-2xl p-6 overflow-hidden text-sm
        bg-white text-gray-800 shadow-md ring-1 ring-black/5
        dark:bg-black/30 dark:text-gray-300 dark:border dark:border-gray-700 dark:shadow-xl dark:ring-0
      "
    >
      <div className="flex justify-between items-center mb-6">
        <h4
          className="
            text-2xl font-bold tracking-wide font-fantasy
            text-gray-900 dark:text-indigo-400
          "
        >
          ⚡ Quick Actions
        </h4>
      </div>

      <div className="grid grid-cols-1 gap-3">
        {/* Order VPS */}
        <a
          href="/order-vps"
          className="
            flex items-center justify-between px-4 py-3 rounded-lg font-medium transition duration-200
            bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400
          "
        >
          <span className="flex items-center gap-2">
            <PlusCircle className="w-5 h-5" /> Order New VPS
          </span>
          →
        </a>

        {/* Billing */}
        <a
          href="/billing"
          className="
            flex items-center justify-between px-4 py-3 rounded-lg font-medium transition duration-200
            bg-green-600 text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-400
          "
        >
          <span className="flex items-center gap-2">
            <CreditCard className="w-5 h-5" /> Billing & Payments
          </span>
          →
        </a>

        {/* Support */}
        <a
          href="/support"
          className="
            flex items-center justify-between px-4 py-3 rounded-lg font-medium transition duration-200
            bg-rose-600 text-white hover:bg-rose-700 focus:outline-none focus:ring-2 focus:ring-rose-400
          "
        >
          <span className="flex items-center gap-2">
            <LifeBuoy className="w-5 h-5" /> Contact Support
          </span>
          →
        </a>
      </div>
    </div>
  );
};

export default CreditsCard;
